import {
    Grid,
    Paper,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import DynamicTable from "./DynamicTable";
import { dashTableColOther } from './constants'
import services from "../../Services";
const { hr } = services;

const HardwareTable = ({ employee, page }) => {


    const [hardwareDetails, setHardwareDetails] = useState()

    const fetchHardwareData = async () => {
        let hardwareData = await hr?.get_employee_hardware(employee)
         
        if (hardwareData)
            setHardwareDetails((prev) => { return prev = [...hardwareData?.data?.rows] })
    }

    useEffect(() => {
        fetchHardwareData()
    }, [])


    let table = {
        header: dashTableColOther,
        rows: hardwareDetails?.map((row, index) => [
            row?.HardwareTypeList?.name,
            row?.HardwareManufacturer?.name,
            row?.ModelNbr,
            row?.HwSerialNbr,
            (row?.Attribute1MacAddress || 'N/A'),
        ])

    }

    return (
        <>
            <Grid xs={12} className="LiqTables" style={{ marginTop: "10px" }}>
                <Grid xs={12} className=" mb14">
                    <DynamicTable tableData={table} />
                </Grid>
                <Paper>
                </Paper>
            </Grid>
        </>

    )
}

export default HardwareTable